import { I18N } from 'aurelia-i18n';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { autoinject } from 'aurelia-framework';
import { CustomNumberFormatterBaseValueConverter } from './CustomNumberFormatterBase';

@autoinject
export class DataTableCellFormatBaseValueConverter {

    protected i18n: I18N = null;

    constructor(i18n: I18N) {
        this.i18n = i18n;
    }

    toView(value, type, configJson, enumItem: any) {
        if (ObjectHelper.IsNotNullAndUndefined(value)) {
            let suffix: string = '';
            if (ObjectHelper.IsNotNullAndUndefined(configJson) && ObjectHelper.IsNotNullAndUndefined(configJson.FieldConfig) && ObjectHelper.IsNotNullAndUndefined(configJson.FieldConfig.CaptionSuffix)) {
                suffix = configJson.FieldConfig.CaptionSuffix;
            }

            switch (type) {
                case 8:
                case 40:
                case 21:
                    {
                        if (ObjectHelper.ObjectIs(value) && ObjectHelper.ObjectIs(enumItem)) {
                            return enumItem.Caption;
                        }
                    }
                case 3:
                case 4:
                    {
                        const customNumberFormatter = new CustomNumberFormatterBaseValueConverter(this.i18n);
                        return customNumberFormatter.toView(value, null, null, type, configJson);
                    }
                case 6:
                    {
                        var txt = document.createElement("textarea");
                        txt.innerHTML = value;
                        return txt.value;
                    }
                case 41:
                    {
                        const customNumberFormatter = new CustomNumberFormatterBaseValueConverter(this.i18n);
                        let minimumFractionDigits = 2;
                        if (ObjectHelper.IsNotNullAndUndefined(configJson) && ObjectHelper.IsNotNullAndUndefined(configJson.FieldConfig) && ObjectHelper.IsNotNullAndUndefined(configJson.FieldConfig.DecimalPlace)) {
                            minimumFractionDigits = configJson.FieldConfig.DecimalPlace;
                        }
                        return customNumberFormatter.toView(value, { minimumFractionDigits: minimumFractionDigits }, null, type, configJson) + suffix;
                    }
                case 7: return moment(value).format('l');
                case 11: return moment(value, ['h:m a', 'H:m']).format('LT');
                case 12: return moment(value).format('l LT');
                case 37: {
                    switch (this.i18n.getLocale().toLowerCase().substring(0, 2)) {
                        case 'en': return moment(value).format('M/D/');
                        default: return moment(value).format('D. M.');
                    }
                }
                case 46: {
                    return moment(value).format('M Y');
                }
                case 1: return value ? this.i18n.tr('Yes') : this.i18n.tr('No');
                default: return String(value);
            }
        }

        return String(value);
    }
}





